import {useMutation, useQueryClient} from "@tanstack/react-query";
import {updateProductGroupIn} from "../../../../../api/product/ProductInApi";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";


export const useUpdateProductGroup = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: {
            "outFlag": string,
            "productExplain": string,
            "new_erp_productid": string,
            "new_l_product_group@odata.bind": string
        }) => updateProductGroupIn(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "저장되었습니다",
                type: "alert",
            });

            qc.invalidateQueries({queryKey: ["readProductDetailIn"]})
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
